import React from 'react';

/**
 * ✨ SACRED GEOMETRY ICON LIBRARY ✨
 * Custom Icons for M.ai.ry / ElchmE / Belonging Sessions
 * Hand-crafted with love - Each icon embodies sacred geometry, alchemy, and belonging themes
 * NO GENERIC ICONS - 100% unique, spiritually-aligned visual language
 */

// Grant Math Spiral Icon - The signature icon
export const SpiralIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 2C12 2 19 5 19 12C19 16 16 19 12 19C8 19 5 16 5 12C5 9 7 7 10 7C13 7 15 9 15 12C15 14 13.5 15.5 12 15.5C10.5 15.5 9.5 14.5 9.5 13C9.5 11.5 10.5 10.5 12 10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="12" cy="12" r="1.5" fill={color} />
  </svg>
);

// Golden Phi Spiral - Sacred geometry
export const PhiSpiralIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path 
      d="M12 3C14.76 3 17 5.24 17 8C17 10.76 14.76 13 12 13"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path 
      d="M12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="12" cy="10" r="1.5" fill={color} />
  </svg>
);

// Belonging Heart - Connected hearts symbol
export const BelongingHeartIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 21L10.55 19.7C5.4 15.1 2 12.1 2 8.5C2 5.4 4.4 3 7.5 3C9.2 3 10.9 3.8 12 5.1C13.1 3.8 14.8 3 16.5 3C19.6 3 22 5.4 22 8.5C22 12.1 18.6 15.1 13.45 19.7L12 21Z"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <circle cx="8" cy="9" r="1" fill={color} />
    <circle cx="16" cy="9" r="1" fill={color} />
    <path d="M8 9C9 11 11 12 12 12C13 12 15 11 16 9" stroke={color} strokeWidth="1" strokeLinecap="round" fill="none" />
  </svg>
);

// Alchemy Gold Symbol - Transformation
export const AlchemyGoldIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="1.5" fill="none" />
    <line x1="12" y1="3" x2="12" y2="8" stroke={color} strokeWidth="1.5" />
    <line x1="12" y1="16" x2="12" y2="21" stroke={color} strokeWidth="1.5" />
    <line x1="3" y1="12" x2="8" y2="12" stroke={color} strokeWidth="1.5" />
    <line x1="16" y1="12" x2="21" y2="12" stroke={color} strokeWidth="1.5" />
    <circle cx="12" cy="12" r="1.5" fill={color} />
  </svg>
);

// Observe Eye - OFNR Observe step
export const ObserveEyeIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 5C7 5 2.73 8.11 1 12C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 12C21.27 8.11 17 5 12 5Z"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <circle cx="12" cy="12" r="3.5" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="1.5" fill={color} />
    <path d="M12 8V9M12 15V16M8 12H9M15 12H16" stroke={color} strokeWidth="1" strokeLinecap="round" />
  </svg>
);

// Feel Heart - OFNR Feel step
export const FeelHeartIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 21L10.55 19.7C5.4 15.1 2 12.1 2 8.5C2 5.4 4.4 3 7.5 3C9.2 3 10.9 3.8 12 5.1C13.1 3.8 14.8 3 16.5 3C19.6 3 22 5.4 22 8.5C22 12.1 18.6 15.1 13.45 19.7L12 21Z"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <path d="M8 10C9 8 11 8 12 10C13 8 15 8 16 10" stroke={color} strokeWidth="1.5" strokeLinecap="round" fill="none" />
  </svg>
);

// Need Seed - OFNR Need step (seed of growth)
export const NeedSeedIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="17" rx="5" ry="3" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M12 14V8" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 8C12 8 9 6 9 4C9 2.5 10.5 2 12 2C13.5 2 15 2.5 15 4C15 6 12 8 12 8Z" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M9 10C8 9 7 9 6 10" stroke={color} strokeWidth="1" strokeLinecap="round" />
    <path d="M15 10C16 9 17 9 18 10" stroke={color} strokeWidth="1" strokeLinecap="round" />
  </svg>
);

// Wisdom Scroll - Daily Wisdom / Papers
export const WisdomScrollIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4C4 2.9 4.9 2 6 2H18C19.1 2 20 2.9 20 4V4C20 5.1 19.1 6 18 6H6C4.9 6 4 5.1 4 4V4Z" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M6 6V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V6" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M9 10H15M9 14H15M9 18H13" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="4" r="1" fill={color} />
  </svg>
);

// Archive Vault - Paper archive
export const ArchiveVaultIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="16" rx="2" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M3 9H21" stroke={color} strokeWidth="1.5" />
    <path d="M10 13H14" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="6.5" r="1" fill={color} />
  </svg>
);

// Return Arrow - Back navigation
export const ReturnArrowIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M10 19L3 12L10 5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 12H14C17.3 12 20 14.7 20 18V19" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Save Thread - Save conversation
export const SaveThreadIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M19 21L12 16L5 21V5C5 3.9 5.9 3 7 3H17C18.1 3 19 3.9 19 5V21Z" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M12 7V12M9.5 9.5L14.5 9.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Fracture Warning - Path A warning
export const FractureWarningIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 20H22L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <path d="M12 9V13" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="16" r="1" fill={color} />
  </svg>
);

// Coherence Leaf - Path B growth
export const CoherenceLeafIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22V12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 12C12 12 6 12 4 8C2 4 6 2 12 2C18 2 22 4 20 8C18 12 12 12 12 12Z" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M12 7C10 9 8 10 6 10" stroke={color} strokeWidth="1" strokeLinecap="round" />
    <path d="M12 7C14 9 16 10 18 10" stroke={color} strokeWidth="1" strokeLinecap="round" />
    <path d="M9 19C10 20 11 21 12 22C13 21 14 20 15 19" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Gear Cog - Settings/Admin
export const SacredGearIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M12 2V5M12 19V22M2 12H5M19 12H22" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M4.93 4.93L7.05 7.05M16.95 16.95L19.07 19.07M4.93 19.07L7.05 16.95M16.95 7.05L19.07 4.93" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="12" r="1" fill={color} />
  </svg>
);

// User Soul - User/Person
export const SoulIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M4 20C4 16.69 7.58 14 12 14C16.42 14 20 16.69 20 20" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="8" r="1.5" fill={color} />
  </svg>
);

// Community Souls - Multiple users
export const CommunitySoulsIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="7" r="3" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="15" cy="7" r="3" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M3 18C3 15.5 5.5 13.5 9 13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M15 13.5C18.5 13.5 21 15.5 21 18" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 13.5C10.5 14.5 13.5 14.5 15 13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="18" r="2" stroke={color} strokeWidth="1.5" fill="none" />
  </svg>
);

// Add/Create Plus
export const CreatePlusIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M12 8V16M8 12H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// View/Preview Eye
export const PreviewEyeIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5C7 5 2.73 8.11 1 12C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 12C21.27 8.11 17 5 12 5Z" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.5" fill="none" />
  </svg>
);

// Edit/Modify Pen
export const ModifyPenIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 3.5L20.5 7.5L7.5 20.5H3.5V16.5L16.5 3.5Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <path d="M14 6L18 10" stroke={color} strokeWidth="1.5" />
  </svg>
);

// Remove/Delete X
export const RemoveXIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M8 8L16 16M16 8L8 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Confirm Check
export const ConfirmCheckIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M8 12L11 15L16 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Refresh/Regenerate Cycle
export const RegenerateCycleIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M4 12C4 7.58 7.58 4 12 4C15.35 4 18.22 6.07 19.42 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M20 12C20 16.42 16.42 20 12 20C8.65 20 5.78 17.93 4.58 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M16 9H20V5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 15H4V19" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Calendar/Date
export const SacredCalendarIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="17" rx="2" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M3 9H21" stroke={color} strokeWidth="1.5" />
    <path d="M8 2V5M16 2V5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="14" r="2" stroke={color} strokeWidth="1.5" fill="none" />
  </svg>
);

// Expand/Collapse Chevrons
export const ExpandDownIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CollapseUpIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M6 15L12 9L18 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Sonic/Sound Wave
export const SonicWaveIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4V20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M8 7V17" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M4 10V14" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M16 7V17" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M20 10V14" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Status/Connection Dot
export const StatusDotIcon = ({ size = 24, className = '', color = 'currentColor', active = true }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="1.5" fill={active ? color : 'none'} />
    {active && <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1" strokeDasharray="2 2" />}
  </svg>
);

// Lightning Bolt - Energy/Pivot
export const LightningBoltIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <circle cx="12" cy="12" r="2" fill={color} opacity="0.5" />
  </svg>
);

// Wrench/Tool - Levers/Actions
export const SacredWrenchIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M14.7 6.3C15.1 5.9 15.6 5.6 16.2 5.3L18.4 3.1C19.2 2.3 20.5 2.3 21.3 3.1C22.1 3.9 22.1 5.2 21.3 6L19.1 8.2C18.8 8.8 18.5 9.3 18.1 9.7L14.7 6.3Z" stroke={color} strokeWidth="1.5" fill="none" />
    <path d="M9.7 14.7C9.3 15.1 8.8 15.4 8.2 15.7L6 17.9C5.2 18.7 3.9 18.7 3.1 17.9C2.3 17.1 2.3 15.8 3.1 15L5.3 12.8C5.6 12.2 5.9 11.7 6.3 11.3L9.7 14.7Z" stroke={color} strokeWidth="1.5" fill="none" />
    <rect x="7.5" y="11" width="9.2" height="2" rx="1" transform="rotate(45 12 12)" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="12" cy="12" r="1.5" fill={color} />
  </svg>
);

// Flask/Beaker - Experiment
export const ExperimentFlaskIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3H15M10 3V8L5 19C4.4 20.2 5.2 21 6.5 21H17.5C18.8 21 19.6 20.2 19 19L14 8V3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <ellipse cx="12" cy="16" rx="4" ry="2" stroke={color} strokeWidth="1.5" fill="none" />
    <circle cx="10" cy="13" r="1" fill={color} />
    <circle cx="14" cy="14" r="0.8" fill={color} />
    <circle cx="12" cy="18" r="0.6" fill={color} />
  </svg>
);

// Warning Triangle - Risks
export const RiskWarningIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 20H22L12 2Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <path d="M12 9V13" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M12 16V17" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Carry to Chat Icon - A flowing wave carrying wisdom to conversation
export const CarryToChatIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Flowing path from left to right */}
    <path 
      d="M3 12C5 9 7 15 9 12C11 9 13 15 15 12C17 9 19 15 21 12" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round"
      fill="none"
    />
    {/* Star/essence at the start */}
    <circle cx="3" cy="12" r="2" fill={color} />
    {/* Arrow pointing to chat bubble */}
    <path d="M18 8L21 12L18 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    {/* Small sparkles */}
    <circle cx="6" cy="8" r="1" fill={color} opacity="0.6" />
    <circle cx="12" cy="6" r="0.8" fill={color} opacity="0.4" />
    <circle cx="15" cy="17" r="0.8" fill={color} opacity="0.5" />
  </svg>
);

// Epic Summary Icon - A scroll unfurling with starlight
export const EpicSummaryIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Unfurling scroll */}
    <path 
      d="M6 4C4.5 4 3 5 3 6.5V17.5C3 19 4.5 20 6 20H18C19.5 20 21 19 21 17.5V8L17 4H6Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Fold corner */}
    <path d="M17 4V8H21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    {/* Star/spark at center */}
    <path d="M12 10L12.5 12L14.5 12L13 13.5L13.5 15.5L12 14.5L10.5 15.5L11 13.5L9.5 12L11.5 12L12 10Z" fill={color} />
    {/* Lines of wisdom text */}
    <path d="M7 17H11" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.6" />
    <path d="M7 15H14" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.4" />
  </svg>
);

// Bliss Abode Icon - Sacred home/sanctuary symbol
export const BlissAbodeIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 3L12 5M12 5C9 5 6 7 4 10L12 8L20 10C18 7 15 5 12 5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path 
      d="M5 10V18C5 19.1 5.9 20 7 20H17C18.1 20 19 19.1 19 18V10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path 
      d="M10 20V16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16V20"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="12" cy="11" r="1.5" fill={color} opacity="0.6" />
  </svg>
);

// Sketch Hub Icon - Creative pencil with artistic flourish
export const SketchHubIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Pencil body */}
    <path 
      d="M4 20L6.5 17.5M6.5 17.5L16 8L18 10L8.5 19.5L4 20L6.5 17.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Pencil tip */}
    <path 
      d="M16 8L18 6C18.5 5.5 19.5 5.5 20 6C20.5 6.5 20.5 7.5 20 8L18 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Creative spark/flourish */}
    <path 
      d="M10 4C10 4 11 6 13 6C15 6 14 4 14 4"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.7"
    />
    {/* Doodle swirl */}
    <path 
      d="M7 7C8 6 10 7 9 9C8 11 6 10 7 8"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      opacity="0.5"
    />
    {/* Small star spark */}
    <circle cx="17" cy="4" r="1" fill={color} opacity="0.6" />
  </svg>
);

export default {
  SpiralIcon,
  PhiSpiralIcon,
  BelongingHeartIcon,
  AlchemyGoldIcon,
  ObserveEyeIcon,
  FeelHeartIcon,
  NeedSeedIcon,
  WisdomScrollIcon,
  ArchiveVaultIcon,
  ReturnArrowIcon,
  SaveThreadIcon,
  FractureWarningIcon,
  CoherenceLeafIcon,
  SacredGearIcon,
  SoulIcon,
  CommunitySoulsIcon,
  CreatePlusIcon,
  PreviewEyeIcon,
  ModifyPenIcon,
  RemoveXIcon,
  ConfirmCheckIcon,
  RegenerateCycleIcon,
  SacredCalendarIcon,
  ExpandDownIcon,
  CollapseUpIcon,
  SonicWaveIcon,
  StatusDotIcon,
  LightningBoltIcon,
  SacredWrenchIcon,
  ExperimentFlaskIcon,
  RiskWarningIcon,
  CarryToChatIcon,
  EpicSummaryIcon,
  BlissAbodeIcon,
  SketchHubIcon
};
